import React from 'react';
import TradeProtectionReact from './TradeProtectionReact';

const TradeProtection: React.FC = () => {
  return <TradeProtectionReact />;
};

export default TradeProtection;
